import React, { useState, useEffect, useContext, useRef } from "react";
import { Formik, Form } from "formik";
import { TextField, MenuItem, Button, CircularProgress } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import * as Yup from "yup";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import SessionStorageService from "../../../services/StorageService";
import { useNavigate } from "react-router-dom";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import FaaliyetListeAPI from "../../../apis/OB/Get/FaaliyetListeAPI";
import EglenceVergiTuruAPI from "../../../apis/OB/Get/EglenceVergiTuruAPI";
import IsletmeTuruListeAPI from "../../../apis/OB/Get/IsletmeTuruListeAPI";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import EvBasvuruSave from "../../../apis/OB/SaveApi/EvBasvuruSave";
import { year } from "../../../helpers/TodayDate";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import CustomDatePicker from "../../../components/OB/required-datepicker";
import CustomTextField from "../../../components/OB/required-text-field";
import { toast } from "react-toastify";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import Recaptcha from "../../../components/Recaptcha";
import DysAPI from "../../../apis/DysAPI";

const validationSchema = Yup.object().shape({
  beyanYili: Yup.number().required("Beyan Yılı gereklidir"),
  beyanAyi: Yup.number().required("Beyan Ayı gereklidir"),
  mukBaslamaTarihi: Yup.date().required("Mük. Başlama Tarihi gereklidir"),
  mukBitisTarihi: Yup.date().required("Mük. Bitiş Tarihi gereklidir"),
  isletmeTuruKodu: Yup.number().required("İşletme Türü gereklidir"),
  mahalleKodu: Yup.number().required("Mahalle gereklidir"),
  caddeSokakKodu: Yup.number().required("Cadde/Sokak gereklidir"),
  butceGelirId: Yup.number().required("Eğlence Vergi Türü gereklidir"),
  faaliyetKodu: Yup.number().required("Faaliyet Adı gereklidir"),
});



const EglenceBasvuru = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const user = SessionStorageService.getUserInfo()
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");

  const navigate = useNavigate();
  const { yilListe, mahalleListe } = useContext(ConstantAPISContext);
  const [caddeListe, setCaddeListe] = useState([]);
  const [isletmeTuruData, setIsletmeTuruData] = useState([]);
  const [eglenceVergiTuruData, setEglenceVergiTuruData] = useState([]);
  const [faaliyetListe, setFaaliyetListe] = useState([]);
  const [oranTarife, setOranTarife] = useState<string | null>(null);
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const [userControlPopup, setUserControlPopup] = useState(false);
  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  }
  const [isLoad, setIsLoad] = useState(true);

  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };

  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 6 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);
  useEffect(() => {

    if (user == null) {

      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }

  }, []);

  useEffect(() => {
    if (user) {
      FaaliyetListeAPI.getFaaliyetListe(undefined)
        .then((res) => setFaaliyetListe(res.data))
        .catch((err) => console.error(err))
    }
  }, []);


  return isLoad ? <>
    <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>

    {userControlPopup ? (
      <div className="popupContainer">
        <div className="popupContent">
          <AciklamaAndUserControlPopup
            open={userControlPopup}
            handleClose={closeUserControlPopup}
            isUserControlPopUp={true}
            description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
          />
        </div>
      </div>
    ) : null}
  </> : (
    <Formik
      initialValues={{
        basvuruTuruId: 6,
        sicilKodu: user?.sicilKodu,
        beyanYili: year,
        beyanAyi: null,
        mukBaslamaTarihi: null,
        mukBitisTarihi: null,
        isletmeTuruKodu: null,
        mahalleKodu: null,
        caddeSokakKodu: null,
        kapiNo: "",
        altKapiNo: "",
        daireNo: "",
        altDaireNo: "",
        butceGelirId: null,
        faaliyetKodu: null,
        adetM2: "",
        ekAdetM2: "",
        gunSayisi: "",
        biletBaslangicNo: "",
        biletBitisNo: "",
        iadeEdilenAdet: "",
        biletAdedi: "",
        biletFiyati: "",
        matrah: "",
        aciklama: "",
      }}
      validationSchema={validationSchema}
      validateOnMount={true}
      onSubmit={async (values: any, { resetForm }) => {
        const missingDocuments = documents
          .filter(doc => doc.isRequired) // zorunlu belgeler
          .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

        if (missingDocuments.length > 0) {
          const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
          toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
          documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          return; // başvuru burada durur
        }

        // reCAPTCHA’yı tetikle
        const token = await recaptchaRef.current?.handleSubmit();
        if (!token) {
          toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
          return;
        }

        setLoadingSubmit(true);
        const transformedValues = {
          ...values,
          basvuruTuruId: Number(values.basvuruTuruId),
          sicilKodu: safelyParseNumber(values.sicilKodu),
          beyanYili: Number(values.beyanYili),
          beyanAyi: Number(values.beyanAyi),
          mukBaslamaTarihi: values.mukBaslamaTarihi.toISOString(),
          mukBitisTarihi: values.mukBitisTarihi.toISOString(),
          isletmeTuruKodu: Number(values.isletmeTuruKodu),
          mahalleKodu: Number(values.mahalleKodu),
          caddeSokakKodu: Number(values.caddeSokakKodu),
          kapiNo: values.kapiNo ? Number(values.kapiNo) : undefined,
          daireNo: values.daireNo ? Number(values.daireNo) : undefined,
          butceGelirId: Number(values.butceGelirId),
          faaliyetKodu: Number(values.faaliyetKodu),
          adetM2: values.adetM2 ? Number(values.adetM2) : undefined,
          ekAdetM2: values.ekAdetM2 ? Number(values.ekAdetM2) : undefined,
          gunSayisi: values.gunSayisi ? Number(values.gunSayisi) : undefined,
          biletBaslangicNo: values.biletBaslangicNo ? Number(values.biletBaslangicNo) : undefined,
          biletBitisNo: values.biletBitisNo ? Number(values.biletBitisNo) : undefined,
          iadeEdilenAdet: values.iadeEdilenAdet ? Number(values.iadeEdilenAdet) : undefined,
          biletFiyati: values.biletFiyati ? Number(values.biletFiyati) : undefined,
          matrah: values.matrah ? Number(values.matrah) : undefined,
          aciklama: values.aciklama || undefined,
          captchaToken: token
        };
        EvBasvuruSave.saveEvBasvuruSave(transformedValues)
          .then(async (res) => {
            console.log(res);
            if (res.data.sonuc === 0) {
              let basvuruNo = res.data.basvuruNo;

              // DYS API'yi çağır 
              try {
                // Sadece dosyası olanları al
                const filesToSend = documents.filter((doc: any) => !!doc.file);

                if (filesToSend.length > 0) {
                  const formData = new FormData();

                  filesToSend.forEach((doc: any) => {
                    formData.append("files", doc.file, doc.file.name);
                    formData.append("rfObBasvuruTanimBelge", String(doc.id));
                  });

                  formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                  formData.append("basvuruId", String(basvuruNo));
                  formData.append("folderName", "AKOS");
                  formData.append("kurumId", "1");
                  formData.append("versionable", "1");

                  const response = await DysAPI.upload(formData);
                  toast.warning(response.message);
                } else {
                  // Burada return yok — sadece DYS çağrısını atlıyoruz.
                  
                }
              } catch (error: any) {
                toast.error("DYS upload hazırlama hatası:", error);
              }

              setPopupAciklama("İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " + basvuruNo);
              resetForm();
              setKayitBasarili(true);
              setDocuments((prevDocs: any[]) =>
                prevDocs.map((doc) => ({
                  ...doc,
                  file: null,
                  fileName: "",
                }))
              );
            } else {
              setPopupAciklama(res.data.sonucAciklama);
            }
          })
          .catch((err) => {
            setPopupAciklama(
              "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
            );
          })
          .finally(() => {
            setIsPopupVisible(true);
            recaptchaRef.current?.reset();
            setLoadingSubmit(false);
          });

        console.log("Transformed Values: ", transformedValues);
      }}
    >
      {({ values, handleChange, setFieldValue, errors, touched }) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (values.mahalleKodu) {
            CaddeSokakAPI.getCaddeSokakListe(undefined, values.mahalleKodu)
              .then((res) => setCaddeListe(res.data))
              .catch((err) => console.error(err));
          }
        }, [values.mahalleKodu]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (values.beyanYili) {
            IsletmeTuruListeAPI.getIsletmeTuruListeListe(values.beyanYili, undefined)
              .then((res) => setIsletmeTuruData(res.data))
              .catch((err) => console.error(err));
            EglenceVergiTuruAPI.getEglenceVergiTuruListe(values.beyanYili, undefined)
              .then((res) => setEglenceVergiTuruData(res.data))
              .catch((err) => console.error(err));
          }
        }, [values.beyanYili]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          // İşletme türüne göre oran veya tarife bilgisini set et
          const selectedIsletmeTuru: any = isletmeTuruData.find(
            (item: any) => item.isletmeTuruKodu === values.isletmeTuruKodu
          );
          if (selectedIsletmeTuru) {
            setOranTarife(selectedIsletmeTuru.oranTarife);
            setFieldValue("adetM2", selectedIsletmeTuru.oranTarife)
          }
        }, [values.isletmeTuruKodu, isletmeTuruData]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showToastIfErrorsExist = () => {
          if (Object.keys(errors).length > 0) {
            focusFirstErrorField();
            toast.error("Lütfen zorunlu alanları doldurun!");

          }
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formRefs = useRef<any>({});
        const focusFirstErrorField = () => {
          const errorKeys = Object.keys(errors);
          if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0];
            console.log(errorKeys[0])
            const element = document.querySelector(`[name="${firstErrorKey}"]`);
            if (element) {
              (element as HTMLElement).focus();
            }
          }
        };

        return (

          <Form>
            <div className="row">
              <div className="col-xl-4 col-lg-6 mb-3">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          select
                          size="small"
                          label="Beyan Yılı"
                          name="beyanYili"
                          value={values.beyanYili}
                          onChange={handleChange}
                          error={touched.beyanYili && !!errors.beyanYili}
                        >
                          {yilListe.map((option) => (
                            <MenuItem key={option.yili} value={option.yili}>
                              {option.yili}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          select
                          size="small"
                          label="Beyan Ayı *"
                          name="beyanAyi"
                          value={values.beyanAyi}
                          onChange={handleChange}
                          error={touched.beyanAyi && !!errors.beyanAyi}
                        >
                          <MenuItem value={1}>Ocak</MenuItem>
                          <MenuItem value={2}>Şubat</MenuItem>
                          <MenuItem value={3}>Mart</MenuItem>
                          <MenuItem value={4}>Nisan</MenuItem>
                          <MenuItem value={5}>Mayıs</MenuItem>
                          <MenuItem value={6}>Haziran</MenuItem>
                          <MenuItem value={7}>Temmuz</MenuItem>
                          <MenuItem value={8}>Ağustos</MenuItem>
                          <MenuItem value={9}>Eylül</MenuItem>
                          <MenuItem value={10}>Ekim</MenuItem>
                          <MenuItem value={11}>Kasım</MenuItem>
                          <MenuItem value={12}>Aralık</MenuItem>
                        </CustomTextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomDatePicker
                          name="mukBaslamaTarihi"
                          label="Mük. Başlama Tarihi *"
                          value={values.mukBaslamaTarihi}
                          onChange={(newValue: any) => setFieldValue("mukBaslamaTarihi", newValue)}
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error: touched.mukBaslamaTarihi && Boolean(errors.mukBaslamaTarihi),
                            }
                          }}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomDatePicker
                          name="mukBitisTarihi"
                          label="Mük. Bitiş Tarihi *"
                          value={values.mukBitisTarihi}
                          onChange={(newValue: any) => setFieldValue("mukBitisTarihi", newValue)}
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error: touched.mukBitisTarihi && Boolean(errors.mukBitisTarihi),
                            }
                          }}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          select
                          size="small"
                          label="İşletme Türü *"
                          name="isletmeTuruKodu"
                          value={values.isletmeTuruKodu}
                          onChange={(e: any) => {
                            handleChange(e);
                            // İşletme türü değiştiğinde oranTarife değerini güncelle
                            const selectedIsletmeTuru: any = isletmeTuruData.find(
                              (item: any) => item.isletmeTuruKodu === Number(e.target.value)
                            );
                            setOranTarife(selectedIsletmeTuru ? selectedIsletmeTuru.oranTarife : null);
                          }}
                          error={touched.isletmeTuruKodu && !!errors.isletmeTuruKodu}
                        >
                          {isletmeTuruData.map((option: any) => (
                            <MenuItem key={option.isletmeTuruKodu} value={option.isletmeTuruKodu}>
                              {option.isletmeTuruAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          select
                          size="small"
                          label="Eğlence Vergi Türü *"
                          name="butceGelirId"
                          value={values.butceGelirId}
                          onChange={handleChange}
                          error={touched.butceGelirId && !!errors.butceGelirId}
                        >
                          {eglenceVergiTuruData.map((option: any) => (
                            <MenuItem key={option.butceGelirId} value={option.butceGelirId}>
                              {option.butceGelirAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          select
                          size="small"
                          label="Mahalle *"
                          name="mahalleKodu"
                          value={values.mahalleKodu}
                          onChange={(e: any) => {
                            handleChange(e);
                            setFieldValue("caddeSokakKodu", null);
                            setCaddeListe([]);
                          }}
                          error={touched.mahalleKodu && !!errors.mahalleKodu}
                        >
                          {mahalleListe.map((option) => (
                            <MenuItem key={option.mahalleKodu} value={option.mahalleKodu}>
                              {option.mahalleAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          select
                          label="Cadde/Sokak *"
                          size="small"
                          name="caddeSokakKodu"
                          value={values.caddeSokakKodu}
                          onChange={handleChange}
                          error={touched.caddeSokakKodu && !!errors.caddeSokakKodu}
                        >
                          {caddeListe.map((option: any) => (
                            <MenuItem key={option.caddeSokakKodu} value={option.caddeSokakKodu}>
                              {option.caddeSokakAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-md-3 mb-3">
                        <TextField
                          fullWidth
                          label="Kapı No"
                          size="small"
                          name="kapiNo"
                          value={values.kapiNo}
                          onChange={handleChange}
                          error={touched.kapiNo && !!errors.kapiNo}
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <TextField
                          fullWidth
                          size="small"
                          label="Alt Kapı No"
                          name="altKapiNo"
                          value={values.altKapiNo}
                          onChange={handleChange}
                          error={touched.altKapiNo && !!errors.altKapiNo}
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <TextField
                          fullWidth
                          label="Daire No"
                          size="small"
                          name="daireNo"
                          value={values.daireNo}
                          onChange={handleChange}
                          error={touched.daireNo && !!errors.daireNo}
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <TextField
                          fullWidth
                          size="small"
                          label="Alt Daire No"
                          name="altDaireNo"
                          value={values.altDaireNo}
                          onChange={handleChange}
                          error={touched.altDaireNo && !!errors.altDaireNo}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 mb-3">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          select
                          label="Faaliyet Adı *"
                          size="small"
                          name="faaliyetKodu"
                          value={values.faaliyetKodu}
                          onChange={handleChange}
                          error={touched.faaliyetKodu && !!errors.faaliyetKodu}
                        >
                          {faaliyetListe.map((option: any) => (
                            <MenuItem key={option.faaliyetKodu} value={option.faaliyetKodu}>
                              {option.faaliyetAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Adet / M2"
                          name="adetM2"
                          size="small"
                          value={values.adetM2}
                          InputProps={{
                            readOnly: true,
                          }}
                          error={touched.adetM2 && !!errors.adetM2}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Ek Adet / M2"
                          name="ekAdetM2"
                          value={values.ekAdetM2}
                          size="small"
                          onChange={handleChange}
                          disabled={oranTarife === "ORAN"}
                          error={touched.ekAdetM2 && !!errors.ekAdetM2}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Gün Sayısı"
                          size="small"
                          name="gunSayisi"
                          value={values.gunSayisi}
                          onChange={handleChange}
                          disabled={oranTarife === "ORAN"}
                          error={touched.gunSayisi && !!errors.gunSayisi}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Bilet Başlangıç No"
                          size="small"
                          name="biletBaslangicNo"
                          value={values.biletBaslangicNo}
                          onChange={handleChange}
                          disabled={oranTarife === "TARIFE"}
                          error={touched.biletBaslangicNo && !!errors.biletBaslangicNo}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Bilet Bitiş No"
                          size="small"
                          name="biletBitisNo"
                          value={values.biletBitisNo}
                          onChange={handleChange}
                          disabled={oranTarife === "TARIFE"}
                          error={touched.biletBitisNo && !!errors.biletBitisNo}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          size="small"
                          label="İade Edilen Bilet"
                          name="iadeEdilenAdet"
                          value={values.iadeEdilenAdet}
                          onChange={handleChange}
                          disabled={oranTarife === "TARIFE"}
                          error={touched.iadeEdilenAdet && !!errors.iadeEdilenAdet}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Bilet Adedi"
                          size="small"
                          name="biletAdedi"
                          value={values.biletAdedi}
                          onChange={handleChange}
                          disabled={oranTarife === "TARIFE"}
                          error={touched.biletAdedi && !!errors.biletAdedi}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Bilet Fiyatı"
                          size="small"
                          name="biletFiyati"
                          value={values.biletFiyati}
                          onChange={handleChange}
                          disabled={oranTarife === "TARIFE"}
                          error={touched.biletFiyati && !!errors.biletFiyati}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Matrah"
                          size="small"
                          name="matrah"
                          value={values.matrah}
                          onChange={handleChange}
                          error={touched.matrah && !!errors.matrah}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 mb-3">
                <div className="card w-100">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">
                        <TextField
                          fullWidth
                          label="Açıklama"
                          size="small"
                          name="aciklama"
                          multiline
                          rows={11.4}
                          value={values.aciklama}
                          onChange={handleChange}
                          error={touched.aciklama && !!errors.aciklama}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div ref={documentTableRef}>
              {!docsLoaded ? (
                <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
              ) : (
                <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
              )}
            </div>
            <div className="row mt-3">
              <div className="col-12 d-flex justify-content-end">
                <Recaptcha
                  ref={recaptchaRef}
                  changeHandleRecaptcha={setRecaptchaPassed}
                />
                <Button color="primary" type="submit"
                  onClick={() => showToastIfErrorsExist()}>
                  Gönder
                </Button>
                {loadingSubmit && (
                  <div
                    style={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(255,255,255,0.6)",
                      zIndex: 1300,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                )}
              </div>
            </div>
            {isPopupVisible && (
              <BilgilendirmePopup
                isSorunBildirPopup={!isPopupVisible}
                closePopup={() => setIsPopupVisible(false)}
                open={isPopupVisible}
                editDescription={popupAciklama}
              />
            )}
          </Form>

        );
      }}
    </Formik>
  );
};

export default EglenceBasvuru;
